import React from 'react'
import PropTypes from 'prop-types'

import {
  getFormattedDateStrFromDateStr,
  getDateStringFromFormattedDateStr,
} from '@util/timeUtil'
import TextInput from '..'

const DateInput = ({
  placeholder, value, onChange, error, onBlur, messageError
}) => {

  const handleInputChange = (e) => {
    const inputValue = e.target.value
    if (inputValue.length === 10) {
      const formattedDate = getFormattedDateStrFromDateStr(inputValue)
      if (formattedDate === 'Invalid date') {
        onChange('')
        return
      }
      onChange(formattedDate)
    } else {
      onChange('')
    }
  }

  return (
    <TextInput
      placeholder={placeholder}
      value={getDateStringFromFormattedDateStr(value)}
      onChange={(e) => handleInputChange(e)}
      error={error}
      onBlur={onBlur}
      errorMessage={messageError}
      type="date"
    />
  )
}

DateInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  onBlur: PropTypes.func,
  messageError: PropTypes.string
}

DateInput.defaultProps = {
  placeholder: '',
  value: '',
  error: false,
  onBlur: null,
  messageError: ''
}

export default DateInput
